import { MenuItem } from './MenuItem';

export const shoppingCartMenuItem: MenuItem = {
	label: 'menu.cart',
	route: '/shopping-cart',
	authenticated: true,
	icon: 'shopping-cart',
};

export const sideMenuConfig: MenuItem[] = [
	{
		label: 'Market Company Invoice',
		route: '/',
		authenticated: true,
		icon: 'taskcard-and-work-order'
	},
	{
		label: 'menu.parts',
		route: '/parts',
		authenticated: false,
		icon: 'service',
	},
	{
		label: 'menu.orders',
		route: '/orders',
		authenticated: true,
		onClickCollapse: true,
		icon: 'taskcard-and-work-order',
	},
	{
		label: 'menu.profile',
		route: '/profile',
		authenticated: true,
		icon: 'user',
	},
];

export const mobileMenuConfig: MenuItem[] = [shoppingCartMenuItem];
